import axios from '../axios'
import config from '../config'

export const propertyContactRequest = (propertyId, message) => {
  return axios.post(
    config.SERVER_URL + '/property/' + propertyId + '/contact_request',
    {
      message
    }
  )
}

export const sendMultipleEmails = (users, message, subject) => {
  return axios.post(`${config.SERVER_URL}/user/massive_emails`, {
    users,
    subject,
    message
  })
}



// WEBPACK FOOTER //
// ./src/sources/MailSource.js